var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.376 0 0 5.376 0 12s5.376 12 12 12 12-5.376 12-12S18.624 0 12 0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "non-hover-inner",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.711 23.414c-1.168.38-2.416.586-3.711.586-1.296 0-2.544-.206-3.714-.587.54.065.74-.286.74-.59l-.005-.678c-.003-.36-.008-.827-.011-1.364-3.338.725-4.043-1.61-4.043-1.61-.545-1.387-1.332-1.756-1.332-1.756-1.09-.746.083-.73.083-.73 1.204.084 1.837 1.237 1.837 1.237 1.071 1.835 2.809 1.305 3.493.997.109-.776.42-1.305.762-1.605-2.665-.303-5.466-1.333-5.466-5.934 0-1.311.467-2.383 1.235-3.223-.123-.304-.535-1.524.117-3.178 0 0 1.008-.322 3.3 1.231.958-.266 1.984-.399 3.005-.404 1.019.005 2.046.138 3.004.404 2.29-1.553 3.296-1.23 3.296-1.23.655 1.653.244 2.873.12 3.177.77.84 1.233 1.912 1.233 3.223 0 4.612-2.805 5.628-5.478 5.925.43.37.814 1.103.814 2.224a351.494 351.494 0 0 1-.015 3.294c0 .305.195.658.736.591Z",
    fill: "#212A31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "hover-inner",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.711 23.414c-1.168.38-2.416.586-3.711.586-1.296 0-2.544-.206-3.714-.587.54.065.74-.286.74-.59l-.005-.678c-.003-.36-.008-.827-.011-1.364-3.338.725-4.043-1.61-4.043-1.61-.545-1.387-1.332-1.756-1.332-1.756-1.09-.746.083-.73.083-.73 1.204.084 1.837 1.237 1.837 1.237 1.071 1.835 2.809 1.305 3.493.997.109-.776.42-1.305.762-1.605-2.665-.303-5.466-1.333-5.466-5.934 0-1.311.467-2.383 1.235-3.223-.123-.304-.535-1.524.117-3.178 0 0 1.008-.322 3.3 1.231.958-.266 1.984-.399 3.005-.404 1.019.005 2.046.138 3.004.404 2.29-1.553 3.296-1.23 3.296-1.23.655 1.653.244 2.873.12 3.177.77.84 1.233 1.912 1.233 3.223 0 4.612-2.805 5.628-5.478 5.925.43.37.814 1.103.814 2.224a351.494 351.494 0 0 1-.015 3.294c0 .305.195.658.736.591Z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.d76c9231b76d9f80e64c174989007b19.svg";
export { ForwardRef as ReactComponent };